import React from 'react';
import { ButtonGroup, Button } from 'rsuite';

interface SegmentedControlButtonsProps<T = string> {
  value?: T;
  setValue: (value: T) => void;
  options: Array<{ value: T; label: string }>;
}

const SegmentedControlButtons = <T extends string>({
  value,
  setValue,
  options,
}: SegmentedControlButtonsProps<T>) => {
  return (
    <ButtonGroup className="segmented-control">
      {options?.map((option) => {
        return (
          <Button
            className={`segmented-btn ${value === option?.value ? 'is-active' : ''}`}
            onClick={() => setValue(option?.value)}
            key={option?.label}
          >
            {option?.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default SegmentedControlButtons;
